import PropTypes from "prop-types";
import { useState } from "react";

// import GraphqlAPIcalls from '../api/graphql';
const SignupController = () => {
  // const { userCreate } = GraphqlAPIcalls();
  const initUser = {
    confirm_password: "",
    email: "",
    firstName: "",
    lastName: "",
    password: ""
  };
  const [user, setUser] = useState(initUser);
  const [validations, setValidation] = useState({
    err: {
      confirm_password: "",
      email: "",
      firstName: "",
      lastName: "",
      password: ""
    },
    err_msg: ""
  });

  // HANDLE CHANGES
  const handleChange = event => {
    const { name, value } = event.target;
    // console.log(name);
    // console.log(value);
    setUser({ ...user, [name]: value });
    setValidation({
      ...validations,
      err_msg: ""
    });
  };

  return {
    handleChange,
    user,
    validations
  };
};

export default SignupController;

SignupController.propTypes = {
  confirm_password: PropTypes.string,
  email: PropTypes.string,
  name: PropTypes.string,
  password: PropTypes.string
};
